import { Nullable } from '@/shared/types/app.types'

export interface LaboratoryStatisticalAnalysisSidebarDateInput {
    labId: number,
    labName: string
}

export interface laboratoriesStatisticalAnalysisSidebarDateInput {
    list: LaboratoryStatisticalAnalysisSidebarDateInput[],
    selection: LaboratoryStatisticalAnalysisSidebarDateInput[]
}

export interface StatisticalAnalysisSidebarDateInputModel {
    startDate: Date
    endDate: Date
    laboratories: LaboratoryStatisticalAnalysisSidebarDateInput[]
}

export interface StatisticalAnalysisSidebarDateInputState {
    startDate: Nullable<Date>
    endDate: Nullable<Date>
    laboratories: laboratoriesStatisticalAnalysisSidebarDateInput
}
export const initialStatisticalAnalysisSidebarDateInputState =
    (): StatisticalAnalysisSidebarDateInputState => {
        const today = new Date()
        return {
            startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7, today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds()),
            endDate: today,
            laboratories: {
                list: [],
                selection: []
            }
        }
    }
